import axios from 'axios';

const CancelToken = axios.CancelToken;

export function createCancelTokenHandler(propertyName: any) {
  // initializing the cancel token handler object
  const cancelTokenHandler: { [key: string]: any } = {};

  // for each property in apiObject, i.e. for each request
  // initializing the cancel token of the request
  const cancelTokenRequestHandler = {
    cancelToken: null as any,
  };

  // associating the cancel token handler to the request name
  cancelTokenHandler[propertyName] = {
    handleRequestCancellation: () => {
      // if a previous cancel token exists,
      // cancel the request
      cancelTokenRequestHandler.cancelToken &&
        cancelTokenRequestHandler.cancelToken.cancel(propertyName);

      // creating a new cancel token
      cancelTokenRequestHandler.cancelToken = CancelToken.source();

      // returning the new cancel token
       
      return cancelTokenRequestHandler.cancelToken;
    },
  };

  return cancelTokenHandler;
}
